import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import { entityPersonasAdapter, EntityPersonasState } from './entity-personas.state';
import { selectAuthUser, selectUserIsLoading } from '../../../core/auth/auth.selectors';
import { selectUsuario } from '../entity-usuarios/entity-usuarios.selectors';

const { selectEntities, selectAll } = entityPersonasAdapter.getSelectors();

export const getError = (state: EntityPersonasState): any => state.error;

export const getIsLoading = (state: EntityPersonasState): boolean =>
  state.isLoading;

export const selectPersonasState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.personas
);

export const selectAllPersonas = createSelector(selectPersonasState, selectAll);
export const selectEntitiesPersonas = createSelector(
  selectPersonasState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectPersonasError = createSelector(
  selectPersonasState,
  getError
);

// MemoizedSelector<object,any>
export const selectPersonasIsLoading = createSelector(
  selectPersonasState,
  getIsLoading
);

// Obtener persona logueada
export const selectAuthPersona = createSelector(
  selectAllPersonas,
  selectUsuario,
  // Cambia la identificacion de la persona
  (personas, user) => {
    if (user && personas) {
      return personas.find(p => p.documentos_persona[0].pais_codigo === user.pais_documento &&
        p.documentos_persona[0].tipo_documento_codigo === user.tipo_documento && p.documentos_persona[0].numero == user.numero_documento)
    } else {
      return null
    }
  }
);

export const selectPersonaUserIsLoading = createSelector(
  selectPersonasIsLoading,
  selectUsuario,
  (p, u) => !p && !u
)
